import React, { useEffect, useState } from 'react';
import GlobalGrid from '../../components/GlobalGrid';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { columns } from './Columns';
import {
  assetCostModelCrud,
  assetCostModelHeaderCrud,
  assetCostModelStatistic,
} from '../../services/AssetCostModelServices/AssetCostModelServices';
import Message from '../../utils/Message/Message';
import { loadingShow } from '../../App';

let current_header_data: any = [];
interface IProps {
  refreshForecast: () => void;
  theHeaderGridRowSelected: (args: any) => void;
  theHeaderGridRowDeselected: (args: any) => void;
}
function ACMHeader({
  refreshForecast,
  theHeaderGridRowDeselected,
  theHeaderGridRowSelected,
}: IProps) {
  const [current_query_header, setCurrent_query_header] = useState('');
  const generateButton = () => {
    return (
      <div>
        <ButtonComponent onClick={handlerOnGenerate}>Generate</ButtonComponent>
      </div>
    );
  };
  const toolbarOptions: any = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      template: generateButton,
    },
  ];
  const handlerOnGenerate = () => {
    if (current_header_data.id !== -0) {
      startForecast(current_header_data.id);
    } else {
      Message.error('A header must be selected to show data.');
    }
  };
  const startForecast = (uniq: number) => {
    let obj = {
      p_id: uniq,
    };
    assetCostModelStatistic()
      .then((respS) => {
        if (respS.data) {
          assetCostModelCrud(obj)
            .then((resp) => {
              Message.success('Success');
              updateHeader(respS.data[0]);
              loadingShow(false);
              refreshForecast();
            })
            .catch((err) => {
              loadingShow(false);
              if (err.response) {
                Message.error(
                  err.response.data +
                    '\n' +
                    err.response.status +
                    '\n' +
                    err.response.headers
                );
              } else if (err.request) {
                Message.error(err.request);
              } else {
                Message.error('Error: ' + err.message);
              }
            });
        } else {
          Message.warning('Error occured when get statisctis data');
        }
      })
      .catch((err) => {
        Message.error('Something got wrong');
      });
  };
  const updateHeader = (statisctis: any) => {
    let obj = {
      ...current_header_data,
      ...statisctis,
      last_amount:
        statisctis.last_diff === 0
          ? 0
          : statisctis.forecast_amount - statisctis.last_diff,
      forecast_date: new Date(),
    };
    assetCostModelHeaderCrud(obj)
      .then((resp) => {
        Message.success('Success');
        setCurrent_query_header(current_query_header + ' ');
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  };
  const handleHeaderGridRowSelected = (args: any) => {
    current_header_data = args.data;
    theHeaderGridRowSelected(args);
  };
  const handleHeaderGridRowDeselected = (args: any) => {
    current_header_data = [];
    theHeaderGridRowDeselected(args);
  };
  useEffect(() => {
    console.log('mounting');
    return () => {
      console.log('unmounting');
    };
  }, []);
  return (
    <GlobalGrid
      id='acmheader'
      columns={columns}
      height={'15vh'}
      query={current_query_header}
      toolbarOptions={toolbarOptions}
      get_query={'asset-cost-model/header/get'}
      add_query={'asset-cost-model/header/create'}
      edit_query={'asset-cost-model/header/edit'}
      delete_query={'asset-cost-model/header/delete'}
      rowSelected={handleHeaderGridRowSelected}
      rowDeselected={handleHeaderGridRowDeselected}
      signalOfLoad={true}
    />
  );
}

export default (ACMHeader);
